import { render, staticRenderFns } from "./levels.vue?vue&type=template&id=3a094fca&scoped=true"
import script from "./levels.vue?vue&type=script&lang=js"
export * from "./levels.vue?vue&type=script&lang=js"
import style0 from "./levels.vue?vue&type=style&index=0&id=3a094fca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a094fca",
  null
  
)

export default component.exports